import { render, staticRenderFns } from "./SamTextListItem.vue?vue&type=template&id=32934d7a&scoped=true&"
import script from "./SamTextListItem.vue?vue&type=script&lang=js&"
export * from "./SamTextListItem.vue?vue&type=script&lang=js&"
import style0 from "./SamTextListItem.vue?vue&type=style&index=0&id=32934d7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32934d7a",
  null
  
)

export default component.exports